import {Component, Inject} from "@angular/core";
import {QuestionCardDirective} from "../../../directives/question-card/question-card.directive";
import {OfferJourneyService} from "../../../services/offer-journey/offer-journey.service";
import {FELLO_JOURNEY_TASK_ID} from "../../../injection-token";
import {FelloVisitorVariables} from "fello-model";

@Component({
  selector: "app-que-buying-preference",
  templateUrl: "./que-buying-preference.component.html",
  styleUrls: ["./que-buying-preference.component.scss"]
})
export class QueBuyingPreferenceComponent extends QuestionCardDirective {
  buyingArea: string;
  buyingPriceLow: number | undefined;
  buyingPriceHigh: number | undefined;
  skipped = false;

  constructor(public offerJourneyService: OfferJourneyService, @Inject(FELLO_JOURNEY_TASK_ID) public taskId: string) {
    super(offerJourneyService, taskId);
    this.buyingArea = this.offerJourney.vars?.buyingArea ?? "";
    this.buyingPriceLow = this.offerJourney.vars?.buyingPriceLow ?? undefined;
    this.buyingPriceHigh = this.offerJourney.vars?.buyingPriceHigh ?? undefined;
    if ((this.offerJourney.vars?.buyingPriceLow && this.offerJourney.vars?.buyingPriceHigh)) {
      this.skipped = true;
    }
  }

  get rangeValid(): boolean {
    return this.buyingPriceLow != null && this.buyingPriceHigh != null && this.buyingPriceLow < this.buyingPriceHigh;
  }

  next(): void {
    this.skipped = false;
    const vars: FelloVisitorVariables = {
      buyingArea: this.buyingArea,
      buyingPriceLow: this.buyingPriceLow,
      buyingPriceHigh: this.buyingPriceHigh
    };
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }

  skip(): void {
    this.skipped = true;
    const vars: FelloVisitorVariables = {};
    this.offerJourneyService.pushOfferJourneyTask(this.taskId, vars).subscribe();
  }
}
